import React, { useState, useContext } from "react";
import girlIMG from "../../assets/app/Presentation/Chica-Banner.png";
import { useTranslation } from "react-i18next";

import "../../styles/app/Presentation.css";
import SpiderWebBackground from "./SpiderWebBackground";
import DemoForm from "./DemoForm";
import { ThemeContext } from "../../contexts/ThemeContext";

const Presentation: React.FC = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }

  const { isLightMode } = themeContext;

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <SpiderWebBackground />
      <DemoForm show={showModal} onClose={() => setShowModal(false)} />
      <section
        id="presentation"
        className="presentation-container"
        data-theme={isLightMode ? "light" : "dark"}
      >
        <div className="presentation-inner">
          <div className="presentation-content">
            <div className="presentation-heading">
              <h1 className="presentation-title">
                {t("presentation.welcome")}
              </h1>
            </div>
            <div className="presentation-description">
              <p>{t("presentation.description")}</p>
            </div>
            <div className="presentation-buttons">
              <button
                className="presentation-button demo-button"
                onClick={() => setShowModal(true)}
              >
                {t("presentation.demoButton")}
              </button>
              <button
                className="presentation-button plans-button"
                onClick={() => scrollToSection("planes")}
              >
                {t("presentation.plansButton")}
              </button>
            </div>
          </div>
          <div className="presentation-image">
            <img src={girlIMG} alt="Chatbot" className="presentation-img" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Presentation;
